import { z } from 'zod';
/**
 * AI-Text-Rewrite (Skill `ai-text-rewrite`, Paket E).
 *
 * Fünf Aktionen, die einen freien Notiz-/Beschreibungs-Text durch das
 * Rewrite-Modell laufen lassen:
 *  - generate    → aus Stichworten einen zusammenhängenden Text erzeugen
 *  - expand      → ausführlicher
 *  - compress    → komprimieren
 *  - rephrase    → umformulieren
 *  - fachsprache → in BayBO-Fachsprache übertragen
 *
 * Die Route ist zustandslos: Text rein, Text raus. Sie schreibt nichts ins
 * Projekt — über Übernehmen und Verwerfen entscheidet der Nutzer im Formular.
 */
export const rewriteAction = z.enum(['generate', 'expand', 'compress', 'rephrase', 'fachsprache']);
/**
 * Mindestlänge des Eingabetexts.
 *
 * `generate` bekommt bewusst eine niedrigere Schwelle: Stichworte wie „RWA
 * fehlt" sind kürzer als ein Satz, und genau daraus soll die Aktion einen Text
 * machen. Die übrigen Aktionen bearbeiten vorhandene Prosa und brauchen
 * entsprechend mehr Substanz.
 */
export const REWRITE_MIN_LENGTH = 5;
export const REWRITE_MIN_LENGTH_GENERATE = 3;
export const REWRITE_MAX_LENGTH = 5000;
/** Mindestlänge für eine Aktion — eine Quelle für Frontend und Backend. */
export function rewriteMinLength(action) {
    return action === 'generate' ? REWRITE_MIN_LENGTH_GENERATE : REWRITE_MIN_LENGTH;
}
export const rewriteRequest = z
    .object({
    text: z.string().min(REWRITE_MIN_LENGTH_GENERATE).max(REWRITE_MAX_LENGTH),
    action: rewriteAction,
    /**
     * Kurzer fachlicher Kontext („Notizen eines Brandschutz-Projekts").
     *
     * DATENMINIMIERUNG: Hier gehören KEINE personenbezogenen Daten hinein —
     * kein Kundenname, keine Anschrift, kein Projekttitel. Das Frontend setzt
     * ausschließlich feste Textbausteine je Feld.
     */
    contextHint: z.string().max(200).optional(),
})
    .strict()
    .superRefine((value, ctx) => {
    const min = rewriteMinLength(value.action);
    if (value.text.trim().length < min) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['text'],
            message: `Text muss mindestens ${min} Zeichen enthalten.`,
        });
    }
});
